import type { DetailedRisk } from '../types/siteRag';

/* FP3 — Risk Matrix axes-without-cells regression
 *
 * The scatter chart only produces dots when every risk carries a valid
 * `riskLevel` (Low/Medium/High) AND `impactLevel` (Green/Amber/Red).
 * Production data has occasionally been observed with one or both fields
 * missing or stringly-typed off the allowed enum — in that case recharts
 * renders the axes (from XAxis/YAxis domain) but no Scatter points, so the
 * user sees an empty matrix.
 *
 * `hasMatrixCoords` filters risks to those that can actually be binned. The
 * matrix surfaces (TypedRiskMatrixPanel and the modern per-type risk-matrix
 * sections) drop the chart entirely rather than render an empty grid when too
 * few risks survive this filter — the numbered detail list conveys the same
 * information without the broken-chart visual artefact.
 *
 * W3 (orphan cleanup) — moved here out of the now-deleted legacy
 * `report/RiskMatrixSection` render body so the only surviving export of that
 * module (this predicate) lives in a lean, dependency-free util.
 */

const VALID_RISK_LEVELS = new Set<DetailedRisk['riskLevel']>(['Low', 'Medium', 'High']);
const VALID_IMPACT_LEVELS = new Set<DetailedRisk['impactLevel']>(['Green', 'Amber', 'Red']);

export function hasMatrixCoords(r: DetailedRisk | undefined | null): boolean {
  if (!r) return false;
  return VALID_RISK_LEVELS.has(r.riskLevel) && VALID_IMPACT_LEVELS.has(r.impactLevel);
}
